module.exports = __webpack_public_path__ + "img/pic-genshin.d3857a3.png";